module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "account-ds"
  }, [_c('div', {
    staticClass: "bar bar-nav account-top-m"
  }, [_c('router-link', {
    staticClass: "button button-link button-nav pull-left",
    attrs: {
      "to": "/customer/account/index"
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  })]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("Facebook Login")])], 1)]), _vm._v(" "), (_vm.errormsg) ? _c('div', {
    staticClass: "fecshop_message"
  }, [_c('div', {
    staticClass: "error-msg"
  }, [_c('div', [_vm._v("\n                    " + _vm._s(_vm.errormsg) + "\n                ")])])]) : _vm._e(), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main container two-columns-left"
  }, [_c('img', {
    attrs: {
      "src": "//img.fancyecommerce.com/images/opc-ajax-loader.gif"
    }
  }), _vm._v("\n            Please wait, get login info from facebook...\n            "), _c('div', {
    staticClass: "clear"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-22cb16e4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/body/customer/google/Loginv.vue
// module id = 235
// module chunks = 1